export default "__VITE_ASSET__478f5801__"